'use strict';

exports.__esModule = true;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.object;


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/propTypes/layer.js
// module id = 64
// module chunks = 0